module.exports = __webpack_public_path__ + "static/media/techno-small.73a9bad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/techno-small.png
// module id = 553
// module chunks = 0